import { B2bCompanyLegalForm, B2bCompanyLegalFormValues } from '@Common/types/bo/b2b/companies';

export const b2bCompanyLegalFormChoices: Array<{ id: B2bCompanyLegalForm; name: string }> =
  B2bCompanyLegalFormValues.map((value) => ({
    id: value,
    name: value === 'other' ? 'resources.bo_common.b2b.companies.choices.legal_form.other' : value,
  }));
